//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import WhProductDeletedListView from '@/views/Warehouse/WhProductDeleted/list'

//
export default {
  path: 'wh_product_deleted',
  component: ModuleLayout,
  children: [
    {
      name: 'wh-product-deleted-list',
      path: '',
      component: WhProductDeletedListView,
    },
  ],
  meta: {
    title: 'Productos eliminados'
  },
}